import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Grid, Box, Step, Stepper, StepContent, StepLabel, Typography } from '@mui/material';
import { makeStyles, styled } from "@mui/styles";
import { HubConnectionBuilder } from '@microsoft/signalr';
import { toast } from 'react-toastify';

//Local imports
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import BackForwardButton from '../../Shared/BackForwardButton';
import { productionSteps, actions, searchTypes, productionStepId, workstationTypes } from '../../../Config/constants';
import { dataService } from '../../../Services/data/data.service'

//Steps
import PalletStep from '../../Steps/PalletStep';
import ProductStep from '../../Steps/ProductStep';
import ActionStep from '../../Steps/ActionStep';

//Dialogs
import SearchDialog from '../../Shared/Dialogs/SearchDialog';
import ActiveSSCCDialog from '../../Shared/Dialogs/ActiveSSCCDialog';
import AuthenticationDialog from '../../Shared/Dialogs/AuthenticationDialog'
import PreviewDialog from '../../Shared/Dialogs/PreviewDialog';


export const OrderOverviewPage = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [userId, setUserId] = useState(null);
    const [loaded, setLoaded] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const [searchType, setSearchType] = useState(null);
    const [action, setAction] = useState(null);
    const [activeProductionOrders, setActiveProductionOrders] = useState([]);
    const [activePalletData, setActivePalletData] = useState(null);
    const [printPreview, setPrintPreview] = useState(null);
    const [printerSelected, setPrinterSelected] = useState(0);
    const [activeWorkstationType, setActiveWorkstationType] = useState(null);

    // Print (logging)
    const [newSSCC, setNewSSCC] = useState(null);
    const [oldSSCC, setOldSSCC] = useState(null);
    const [productId, setProductId] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [printReasonId, setPrintReasonId] = useState(2);
    const [printReasonDescription, setPrintReasonDescription] = useState(null);
    const [printsQuantity, setPrintsQuantity] = useState(1);

    //Dialog functions
    const [authenticateDialogOpen, setAuthenticateDialogOpen] = useState(false);
    const [searchDialogOpen, setSearchDialogOpen] = useState(false);
    const [activeSSCCDialogOpen, setActiveSSCCDialogOpen] = useState(false);
    const [previewDialogOpen, setPreviewDialog] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const appSettings = props.appSettings;

    useEffect(() => {
        let selectedWorkstation = props.workstation.activeWorkstations.find(x => x.Id == props.workstation.selectedWorkstation)
        setActiveWorkstationType(selectedWorkstation.WorkstationTypeId)
        if (activePalletData === null) {
            dataService.getDataByWorkstationId(props.workstation.selectedWorkstation).then(result => {
                if (result && result !== null && result !== undefined && result.ok) {
                    setActivePalletData(result.data.Results[0]);
                    if (result.data.Results[0].PalletModel !== null && result.data.Results[0].PalletModel !== undefined) {
                        setOrderId(result.data.Results[0].PalletModel.ProductionOrderId);
                    }
                    if (result.data.Results[0].ProductModel !== null && result.data.Results[0].ProductModel !== undefined) {
                        setProductId(result.data.Results[0].ProductModel.Id);
                    }
                }
            });
        }
    }, []);

    useEffect(() => {
        const newPalletConnection = new HubConnectionBuilder()
            .withUrl(appSettings.PALLET_HUB_URL)
            .withAutomaticReconnect()
            .build();
        newPalletConnection.start().then(_ => {
            console.log('Pallet hub connected!');
        }).catch(e => console.log('Pallet hub connection failed: ', e));

        newPalletConnection.on('ReceiveMachineData', palletData => {
            console.log('Pallet hub data received');
            setActivePalletData(palletData);
        });
    }, []);

    //**** START: Generating front-end ****/
    const ColorlibStepIcon = (id) => {
        var active = id === activeStep;
        var completed = id > activeStep;
        return (
            <Box className={classes.stepButton} sx={{ background: active ? FlagstoneTheme.palette.primary.main : (completed ? FlagstoneTheme.palette.primary.main : FlagstoneTheme.palette.primary.main), fontWeight: '600' }} >
                {id + 1}
            </Box>
        );
    };

    const generateStepContent = (id) => {
        //Function is used to generate the different steps in the process (Can be added as a constant)
        switch (id) {
            case productionStepId.PALLET_SCAN:
                //PALLET_SCAN - 0
                return <PalletStep props={props} activePalletData={activePalletData} openActionDialog={openActionDialog} />;
            case productionStepId.PRODUCT_SCAN:
                //PRODUCT_SCAN - 1
                return <ProductStep props={props} activePalletData={activePalletData} />;
            case productionStepId.EXTRA:
                //EXTRA - 2
                return <ActionStep props={props} activePalletData={activePalletData}
                    openActionDialog={openActionDialog}
                ></ActionStep>;
            default:
                return <div>Error: Invalid step</div>;
        }
    };
    //**** END: Generating front-end ****/

    //**** START: Authentication functions ****/
    const authenticateAndTriggerAction = (userId) => {
        //Call the correct function after authenticating
        // switch (action) {
        //     case actions.SEARCH_SSCC:
        //         // openSearchDialog(searchTypes.SSCC, userId);
        //         p
        //         return true;
        //     case actions.ACTIVE_SSCC:
        //         // openActiveSSCCDialog(userId);
        //         return true;
        //     case actions.SEARCH_PRODUCT:
        //         // openSearchDialog(searchTypes.PRODUCT, userId);
        //         return true;
        //     case actions.PRINT_PREVIEW:
        //         openPreviewLabel(userId);
        //         return true;
        //     default:
        //         return <div>Error: Invalid step</div>;
        // }
    };

    const closeAuthenticationDialog = () => {
        setAuthenticateDialogOpen(false);
        setSubmitting(false);
    }

    const openActionDialog = (actionToBeTriggered) => {
        setAction(actionToBeTriggered);
        switch (actionToBeTriggered) {
            case actions.SEARCH_SSCC:
                openSearchDialog(searchTypes.SSCC);
                return true;
            case actions.ACTIVE_SSCC:
                openActiveSSCCDialog();
                return true;
            case actions.SEARCH_PRODUCT:
                openSearchDialog(searchTypes.PRODUCT);
                return true;
            case actions.PRINT_PREVIEW:
                openPreviewLabel();
                return true;
            default:
                return <div>Error: Invalid step</div>;
        }
    }

    const openAuthenticateDialog = () => {
        setAuthenticateDialogOpen(true);
    };
    //**** END: Authentication functions ****/

    //**** START: Search functions ****/
    const openSearchDialog = (chosenSearchType, tempUserId) => {
        if (userId === null) {
            setUserId(tempUserId);
        }
        setAuthenticateDialogOpen(false);
        setSearchType(chosenSearchType);
        setSearchDialogOpen(true);

    };

    const closeSearchDialog = () => {
        setUserId(null);
        setPrintPreview(null);
        setPrinterSelected(null);
        setSearchType(null);
        setSearchDialogOpen(false);
    };
    //**** END: Search functions ****/

    //**** START: ACTIVE SSCC ****/
    const openActiveSSCCDialog = () => {
        setPrinterSelected(null);
        setPrintPreview(null);
        setAuthenticateDialogOpen(false);

        // dataService.getActiveProductionOrdersByProduct(activePalletData.PalletModel.ProductCode, props.workstation.selectedWorkstation, userId !== null ? userId : -1).then(result => {
        //     if (result !== null && result !== undefined && result.ok) {
        //         setActiveSSCCDialogOpen(true);
        //         setActiveProductionOrders(result.data.Results);
        //     }
        // }).catch((error) => {
        //     console.log('error ', error)
        // });

        dataService.getActiveProductionOrders(props.workstation.selectedWorkstation, userId !== null ? userId : -1).then(result => {
            if (result !== null && result !== undefined && result.ok) {
                setActiveSSCCDialogOpen(true);
                setActiveProductionOrders(result.data.Results);
            }
        }).catch((error) => {
            console.log('error ', error)
        });
    };

    const closeActiveSSCCDialog = () => {
        //Show all active SSCC's and give the user the option to use them on the currect workstation
        setUserId(null);
        setPrintPreview(null);
        setPrinterSelected(null);
        setActiveSSCCDialogOpen(false);
    };
    //**** END: ACTIVE SSCC ****/

    //**** START: PREVIEW LABEL ****/
    const openPreviewLabel = () => {
        //After authenticating the user gets the option to view the linked label, here they will also get the option to reprint if necessary;
        setAuthenticateDialogOpen(false);
        var tempActivePalletData = JSON.parse(JSON.stringify(activePalletData));
        var tempSSCC = tempActivePalletData.PalletModel.SSCC;
        var tempUserId = userId !== null && userId !== undefined ? userId : -1;
        dataService.getPrintPreviewBySSCC(tempSSCC, props.workstation.selectedWorkstation, tempUserId).then(result => {
            if (result !== '' && result !== null && result !== undefined && result.ok) {
                setPrintPreview(result.data.Results[0]);
                setPreviewDialog(true);
            } else {
                //Problemen
            }
        }).catch((error) => {
            console.log('error ', error)
        });
    };

    const closePreviewDialog = () => {
        setUserId(null);
        setPrintPreview(null);
        setPreviewDialog(false);
        setPrinterSelected(0);
    };

    const resetLoggingValues = () => {
        setNewSSCC(null);
        setOldSSCC(null);
        setProductId(null);
        setOrderId(null);
        setPrintReasonId(2);
        setPrintReasonDescription(null);
        setPrintsQuantity(1);
    };

    const handlePrintPreview = (tempUserId) => {
        var tempActivePalletData = JSON.parse(JSON.stringify(activePalletData));
        var tempPrinter = tempActivePalletData.Printlocations.find(x => x.Id === printerSelected);

        let oldSscc = '';

        if(activePalletData.PalletModel != null && activePalletData.PalletModel != undefined){
            oldSscc = activePalletData.PalletModel.SSCC;
        }
        
        var tempSSCC = '';
        if (newSSCC !== null && newSSCC !== undefined && newSSCC !== '') {
            tempSSCC = newSSCC;
        } else {
            if(tempActivePalletData.PalletModel != null && tempActivePalletData.PalletModel != undefined){
                tempSSCC = tempActivePalletData.PalletModel.SSCC;
            }
        }

        dataService.printLabel(printerSelected, props.workstation.selectedWorkstation, oldSscc, tempSSCC, orderId, tempUserId, productId, printReasonId, printReasonDescription, printsQuantity).then(result => {
            if (result !== '' && result !== null && result !== undefined && result.ok) {
                closeSearchDialog();
                closeActiveSSCCDialog();
                closePreviewDialog();
                setAuthenticateDialogOpen(false);
                setPreviewDialog(false);
                var feedbacktext = t('Label will be printed on printer') + ': ' + tempPrinter.Name;
                toast.success(feedbacktext, { position: "top-center" })
                resetLoggingValues();
            } else {
                toast.error(t('Error while printing label'), { position: "top-center" })
                closeSearchDialog();
                closeActiveSSCCDialog();
                closePreviewDialog();
                //Problemen
            }
        }).catch((error) => {
            console.log('error ', error)
        });
    }
    //**** END: PREVIEW LABEL ****/

    return <div className={classes.backGround}>
        <div className={classes.spacer80}>
            <div className={classes.left}>
                <NavLink className={classes.navButton} to={`/`}>
                    <BackForwardButton direction={'Back'} textOverride={t("Back to checkpoints")}></BackForwardButton>
                </NavLink>
                {/* <div className={classes.title}>{t('Production queue')}</div> */}
            </div>
        </div>
        {loaded &&
            <Box p={3} pt={0}>

                <Stepper activeStep={activeStep} orientation="vertical"  >
                    {activeWorkstationType && productionSteps.map((productionStep, productionStepIndex) => {
                        // Skip step 2 (index 1) if workstationType is 2
                        if (productionStepIndex === 1 && activeWorkstationType === workstationTypes.MANUAL_VALIDATION) {
                            return null;
                        }

                        return <Step key={productionStep.id} sx={{}} expanded={true}>

                            <StepLabel sx={{}} StepIconComponent={() => ColorlibStepIcon(productionStepIndex > 1 && activeWorkstationType === workstationTypes.MANUAL_VALIDATION ? productionStep.id - 1 : productionStep.id)} >
                                <Typography>{t(productionStep.name)}</Typography>
                            </StepLabel>
                            <StepContent>
                                <Box sx={{}}>
                                    {/* <Typography>{productionStep.description}</Typography> */}
                                    <Box sx={{ position: 'relative', }}>
                                        {generateStepContent(productionStep.id)}
                                    </Box>
                                </Box>
                            </StepContent>
                        </Step>
                    })}
                </Stepper>
            </Box>
        }
        {authenticateDialogOpen &&
            <AuthenticationDialog dialogOpen={authenticateDialogOpen} closeAuthenticationDialog={closeAuthenticationDialog} authenticateAndTriggerAction={handlePrintPreview} openActiveSSCCDialog={openActiveSSCCDialog} setUserId={setUserId} workstationId={props.workstation.selectedWorkstation}></AuthenticationDialog>
        }
        {searchDialogOpen &&
            <SearchDialog dialogOpen={searchDialogOpen} closeDialog={closeSearchDialog} submitting={submitting} setSubmitting={setSubmitting} setNewSSCC={setNewSSCC} setOrderId={setOrderId} setProductId={setProductId} setPrintsQuantity={setPrintsQuantity} searchType={searchType} userId={userId} workstationId={props.workstation.selectedWorkstation} printers={activePalletData.Printlocations} handlePrintPreview={handlePrintPreview} setPrinterSelected={setPrinterSelected} printerSelected={printerSelected} printPreview={printPreview} setPrintPreview={setPrintPreview} openAuthenticateDialog={openAuthenticateDialog}></SearchDialog>
        }
        {activeSSCCDialogOpen &&
            <ActiveSSCCDialog dialogOpen={activeSSCCDialogOpen} submitting={submitting} setSubmitting={setSubmitting} setPrintReasonId={setPrintReasonId} setPrintsQuantity={setPrintsQuantity} setPrintReasonDescription={setPrintReasonDescription} setNewSSCC={setNewSSCC} setOrderId={setOrderId} setProductId={setProductId} setPrinterSelected={setPrinterSelected} activeProductionOrders={activeProductionOrders} openAuthenticateDialog={openAuthenticateDialog} closeDialog={closeActiveSSCCDialog} userId={userId} workstationId={props.workstation.selectedWorkstation} printers={activePalletData.Printlocations} printReasons={activePalletData.PrintReasons}></ActiveSSCCDialog>
        }
        {previewDialogOpen &&
            <PreviewDialog dialogOpen={previewDialogOpen} action={openAuthenticateDialog} closeDialog={closePreviewDialog} submitting={submitting} setSubmitting={setSubmitting} printPreview={printPreview} userId={userId} workstationId={props.workstation.selectedWorkstation} printers={activePalletData.Printlocations} setPrinterSelected={setPrinterSelected} printerSelected={printerSelected}></PreviewDialog>
        }

    </div>
}

const useStyles = makeStyles({
    backGround: {
        paddingTop: "20px",
        position: "relative",
        width: "100%",
        display: 'flex',
        flexDirection: 'column'
    },


    navButton: {
        textDecoration: "none",
        border: "none",
        outline: "none",
        marginLeft: "18px"
    },
    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        paddingLeft: "5px",
        marginLeft: "20px"
    },
    date: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginTop: "4px",
        paddingLeft: "7px",
        marginBottom: "3px",
        marginLeft: "20px"
    },
    stepButton: {
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    search: {
        backgroundColor: "white",
        top: "5px",
        right: "30px",
        '&:hover': {
            boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
            background: "#f5f5f5"
        },
    },
    left: {
        width: "45%",
        // height: "70px",
        float: 'left'
    },
    right: {
        width: "55%",
        height: "90px",
        float: 'right',
        textAlign: "right",

    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    noOrdersFound: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        color: "#8D8D8D",
        padding: "10px",
        marginLeft: "10px"
    },
    searchContainer: {
        width: "200px",
        float: "right",
        height: "98px",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'

    },
    statusContainer: {
        width: "35%",
        float: "right",
        height: "95px",
        paddingTop: "5px",
        boxSizing: "border-box",
        marginRight: "50px"
    },


});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        user: state.user,
        general: state.general
    }
}

export default connect(mapStateToProps)(OrderOverviewPage)